module.exports = __webpack_public_path__ + "static/media/qb.1570fa68.png";